export const QUERY_KEY_APP_VERSION = "app-version";
